export default new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'dropdownBg',
    {
      var: 'components.dropdown.bg',
      cssVar: 'dropdown-bg',
    },
  ],
  [
    'dropdownHoverBg',
    {
      var: 'components.dropdown.hover.bg',
      cssVar: 'dropdown-hover-bg',
    },
  ],
  [
    'dropdownBorderColor',
    {
      var: 'components.dropdown.borderColor',
      cssVar: 'dropdown-border-color',
    },
  ],
  [
    'dropdownBorderWidth',
    {
      var: 'components.dropdown.borderWidth',
      cssVar: 'dropdown-border-width',
    },
  ],
  [
    'dropdownBorderRadius',
    {
      var: 'components.dropdown.borderRadius',
      cssVar: 'dropdown-border-radius',
    },
  ],
  [
    'dropdownElevation',
    {
      var: 'components.dropdown.elevation',
      cssVar: 'dropdown-elevation',
    },
  ],
  [
    'dropdownColorPrimary',
    {
      var: 'components.dropdown.colorPrimary',
      cssVar: 'dropdown-color-primary',
    },
  ],
  [
    'dropdownColorSecondary',
    {
      var: 'components.dropdown.colorSecondary',
      cssVar: 'dropdown-color-secondary',
    },
  ],
  [
    'dropdownFooterBg',
    {
      var: 'components.dropdown.footer.bg',
      cssVar: 'dropdown-footer-bg',
    },
  ],
]);
